module.exports = __webpack_public_path__ + "img/f5.dfd77df4.png";